module.exports = __webpack_public_path__ + "static/media/jamie-sparker-modeling.367a750f.jpg";